import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Typography as T } from '@dev/ee-components';
import { Alert } from '@material-ui/lab';

import Props from './DeleteProps';

const DialogContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    .MuiCheckbox-root {
        padding: 4px 9px;
    }
    .MuiInputBase-root {
        margin-bottom: 16px;
    }
`;
export const DeleteList = (props: Props): JSX.Element => {
    const { t } = useTranslation();

    return (
        <DialogContainer>
            <T variant="body1">{props.isList ? t('deletelistmsgbasic') : t('deletesegmentmsgbasic')}</T>
            <Alert severity="info">
                <T variant="body1">{t('deletecontactsstaymsg')}</T>
            </Alert>
        </DialogContainer>
    );
};
